import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function InfoWatchlistText() {
  
  return (
    
  <Typography variant="subtitle1">

<Typography component="span" variant="subtitle1" sx={{fontWeight: 400}}>Important Read</Typography>
<br /><br /> 

Your genetics can significantly influence how your body processes medications. 
Understanding this can help personalize your treatments, avoid unwanted side effects, and improve therapeutic outcomes. 
This section explains how to interpret your results, why they matter, and how they support clinical decisions.
<br /><br /> 

<Typography component="span" variant="subtitle1" sx={{fontWeight: 400}}>What Is Pharmacogenetics?</Typography>
<br /><br /> 

Pharmacogenetics is the study of how your genetic makeup affects the way your body responds to medications. 
Everyone metabolizes drugs differently. Some people break down active substances faster, others more slowly. 
These differences can influence how effective a medication is, how long it stays in your system, and whether you are more likely to experience side effects. 
This module identifies gene variants that affect drug metabolism. By using this information, 
your doctor can select the right medication at the right dose - minimizing trial and error and maximizing treatment success.

 <br /><br /> 
<Typography component="span" variant="subtitle1" sx={{fontWeight: 400}}>Why Are Genes Involved?</Typography>
<br /> <br /> 

When you take a medication, enzymes in your body work to activate, deactivate, or eliminate the drug. 
These enzymes are produced based on instructions in your DNA. If you carry certain genetic variants, 
those enzymes may work faster, slower, or not at all - changing how a drug behaves in your body. 
This means that the same medication and dose can work well for one person but cause side effects or not work at all for another.

<br /><br /> 
<Typography component="span" variant="subtitle1" sx={{fontWeight: 400}}>How to Read Your Results</Typography>
<br /> <br /> 
In this section, we examine <Typography component="span" fontWeight={600}>23 pharmacogenetically relevant genes</Typography>. For each gene, you will see:​

<ul style={{ paddingLeft: '20px' }}>
<li>
<Typography component="span" fontWeight={600}>PGx Gene</Typography>: The gene known to impact the metabolism of certain drugs.
</li>
<li>
<Typography component="span" fontWeight={600}>Genotype</Typography>: Your specific genetic result for that gene. Genotype refers to the specific versions of a gene you carry. *1 or *wt (wildtype) usually indicate normal function, while numbers like *9 or *17 reflect variants that may increase or reduce enzyme activity.
</li>
<li>
<Typography component="span" fontWeight={600}>Phenotype</Typography>: The predicted effect on enzyme activity (such as Normal Function, Intermediate Metabolizer, Ultrarapid Metabolizer).
</li>
<li>
<Typography component="span" fontWeight={600}>Related Drugs</Typography>: Medications that are known to be influenced by variants in this gene.
</li>
</ul>

The table is intended to give a gene-based overview. If you want to see detailed recommendations per drug (such as dose adjustments or alternative options), 
use the "Medication Guide" tab. There, you can search for specific medications and receive recommendations tailored to your profile.
  <br /> <br />
 
These results are based on international clinical guidelines and may be used by your doctor or pharmacist to adjust treatment plans accordingly. 
If you have questions or are considering medication changes, we recommend discussing these results with your prescribing physician or a 
clinical pharmacogenetics specialist.
 <br /> <br />
<Typography component="span" variant="subtitle1" sx={{fontWeight: 400}}>Abbreviations used in the results:</Typography>
    <br /><br />
    CBZ - carbamazepine,<br /> NVI - No Variant Identified,<br /> CVI – Cerebrovascular Incident or Cerebrovascular Insufficiency,<br />
     non-ACS – Non-Acute Coronary Syndrome,<br /> non-PCI – Non-Percutaneous Coronary Intervention,<br /> PHT - phenytoin,<br /> OXC - oxcarbazepine

</Typography>    


   )
}